import { Pressable } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";
import { Text, View } from "@src/components";
import { useRouter } from "expo-router";
import { useImpersonationSettings } from "../hooks/useImpersonationSettings";

const VI_NAVY_MID = "#151733";
const VI_TEXT = "#f0eef5";
const VI_ACCENT = "#e8456b";

export const ImpersonationBanner = () => {
  const router = useRouter();
  const { impersonatedUserId, impersonatedLabel, clearImpersonation } = useImpersonationSettings();

  if (!impersonatedUserId) {
    return null;
  }

  const displayLabel = impersonatedLabel ?? impersonatedUserId;

  const handleClearImpersonation = () => {
    clearImpersonation();
    router.replace("/");
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Text textStyle="xxs/semibold" style={styles.eyebrow}>
          Impersonation active
        </Text>
        <Text textStyle="xs/medium" style={styles.message} lineClamp={1}>
          Viewing as {displayLabel}
        </Text>
      </View>

      <Pressable accessibilityRole="button" onPress={handleClearImpersonation} style={styles.clearButton}>
        <Icon name="close" size={14} color={VI_TEXT} />
        <Text textStyle="xxs/semibold" style={styles.clearText}>
          Clear
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create((theme) => ({
  container: {
    backgroundColor: VI_NAVY_MID,
    borderBottomWidth: 2,
    borderBottomColor: "rgba(232, 69, 107, 0.38)",
    minHeight: 56,
    paddingVertical: theme.spacing.lg,
    paddingHorizontal: theme.spacing["5xl"],
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.md,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  eyebrow: {
    color: VI_ACCENT,
    textTransform: "uppercase",
    letterSpacing: 1.2,
    marginBottom: 2,
  },
  message: {
    color: VI_TEXT,
    lineHeight: 18,
  },
  clearButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing.xs,
    borderRadius: theme.spacing.lg,
    borderWidth: 1,
    borderColor: "rgba(232, 69, 107, 0.5)",
    backgroundColor: "rgba(232, 69, 107, 0.16)",
    paddingHorizontal: theme.spacing.md,
    paddingVertical: theme.spacing.xs,
  },
  clearText: {
    color: VI_TEXT,
    textTransform: "uppercase",
    letterSpacing: 1.1,
  },
}));
